<div class="radio-wrapper">
  <input
    type="radio"
    (change)="onInputChange($event)"
    [checked]="selected"
    class="pure"
  /><label></label>
</div>
